export default {
  beforeCreate() {
    this.$on('account-loaded', () => {
      const { permissions } = this.$store.state['admin-auth'].accountMeta
      this.$store.commit('gate/setPermissions', permissions)
    })
  },
}
